<template>
  <div class="input-box">
    <label v-if="label !== null" class="label-text">{{label}}</label>
<!--    <label v-if="label !== undefined" class="label-text">{{label}}-->
<!--      <a v-if="label != null" :href="href" target="_blank">#{{hrefText}}</a>-->
<!--    </label>-->
    <validation-provider name="baseInputEditValidationProvider" ref="validationInput" :rules="rules" v-slot="{errors, valid}">
      <div class="select-contain form-group mt-auto mb-auto" :class="errors.length > 0 ? 'error' : ''" style="width: auto;">
        <select v-model="displayModel" class="select-contain-select" type="text" placeholder="">
          <option v-for="option in optionList" v-if="canSelectRoom(option)" :value="option.id" v-bind:key="option.id">
            {{option.roomNumber}} {{option.ros ? '(ROS)' : ''}} - {{  getRoomName(option.roomId) }}
          </option>
        </select>
        <small class="error-text">{{errors[0]}}</small>
      </div>
    </validation-provider>
  </div>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate';
import { alpha, required } from 'vee-validate/dist/rules';
import validationMethodsMixin from "../../mixin/validationMethodsMixin";

export default {
  name: "BaseSelectInput",
  mixins : [validationMethodsMixin],
  components : {ValidationProvider},
  data :() => {
    return {
      valid : null,
      displayModel : null
    };
  },
  props : {
    href : null,
    hrefText : null,
    label : null,
    optionList : null,
    type : String,
    rules : String,
    inputModel : null
  },
  model: {
    prop: 'inputModel',
    event: 'change'
  },
  computed: {
    roomList:{
      get(){
        return this.$store.getters.getRoomList;
      }
    },
    roomMap:{
      get(){
        let roomList = this.$store.getters.getRoomList;
        if(roomList == null){
          return null;
        }
        return roomList.reduce(function (map, cabinType) {
          map[cabinType.id] = cabinType;
          return map;
        }, {});
      }
    }
  },
  mounted() {
    alpha.message =  'Not alpha numeric';
    extend("alpha", alpha);


    extend("required", {...required,
        message : required.message =  'Required'});

    this.displayModel = this.inputModel;
    this.$nextTick(()=>{
      $(".select-contain-select").selectpicker({
        size: 5,
        noneSelectedText: 'Select One'});
      $(".select-contain-select").selectpicker('refresh');
    })
  },
  methods:{
    canSelectRoom:function (cruiseCabin){
      try {
        if(cruiseCabin.bookingDetail.isBooked || cruiseCabin.bookingDetail.blocked){
          return false;
        }
      }catch (Ex){}
      return true;
    },
    getRoomName:function (roomId){
      if(this.roomMap === null){
        return "";
      }
      return this.roomMap[roomId].name;
    }
  },
  watch: {
    displayModel: {
      handler: function () {
        this.$nextTick(()=>{
          $(".select-contain-select").selectpicker({
            size: 5,
            noneSelectedText: 'Select One'});
          $(".select-contain-select").selectpicker('refresh');
        })
      }
    }
  }
}
</script>

<style scoped>

</style>